import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserContext } from '../../../contexts/user';

import Routes from '../../routes';

import { useAnalyticsContext } from '../../../contexts/analytics';
import { cn, FieldVariantProvider } from '@datanomik/core-ui';
interface AppProps {
  className?: string;
}

const App = ({ className }: AppProps) => {
  const { t } = useTranslation();
  const { userIsLogged } = useUserContext();
  const {
    hotJar: { initHotjar },
  } = useAnalyticsContext();

  useEffect(() => {
    initHotjar();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const boxClasses = {
    'dn-app': true,
    [className]: className,
    'dn-public': !userIsLogged(),
    'dn-private': userIsLogged(),
  };

  return (
    <div className={cn(boxClasses)}>
      <FieldVariantProvider toolbarEmptySelection={t('All')}>
        <Routes />
      </FieldVariantProvider>
    </div>
  );
};
export default App;
